import { ConfigService } from '../../infra/config'
import { BaseRepository } from '../../infra/base.repository'
import type { Creative } from './creative'

export class CreativesRepository extends BaseRepository<Creative> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.brokerApiUrl + '/' + 'creatives', token, cache)
    }

    async syncWabaTemplates(): Promise<any> {
        const { json, statusCode, message } = await this.request.get(this.config.brokerApiUrl + '/creatives/sync?token=' + this.resolvedToken)
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async addDefaultTemplates(wabaId: string): Promise<any> {
        const { json, statusCode, message } = await this.request.get(
            this.config.brokerApiUrl + '/creatives/add-default?wabaId=' + wabaId + '&token=' + this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }
}
